export function useGetProduct() {
    const { apiClient } = useShopwareContext();

    const getProducts = async (productIds: string[] | undefined) => {
        if (!productIds?.length) {
            return { data: null };
        }

        return useAsyncData(`product-${productIds.join('|')}`, async () => {
            try {
                return (
                    await apiClient.invoke('getProduct post /product', {
                        headers: {
                            'sw-include-seo-urls': 'true',
                        },
                        body: {
                            ids: productIds,
                            limit: productIds.length,
                            associations: {
                                vendorsAvailableSalesChannels: {},
                            },
                        },
                    })
                ).data;
            } catch (error) {
                return null;
            }
        });
    };

    return {
        getProducts,
    };
}
